import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { Image, WarningPopUp } from "hesus-ui-kit";
import { handleApiError } from "@utils/errorHandler";
import { ButtonContainer } from "../../PurchaseOrderList.styled";
import deleteIcon from "@icons/ic-delete-red.svg";
import editIcon from "@icons/ic-edit-blue.svg";
import viewIcon from "@icons/ic-view-dark-blue.svg";
import "../../PurchaseOrderList.scss";
import AddEditPurchaseOrder from "@modules/PurchaseOrder/AddEditPurchaseOrder/AddEditPurchaseOrder";
import PurchaseOrderView from "@modules/PurchaseOrder/PurchaseOrderView/PurchaseOrderView";

const Action = (props) => {
  const {
    t,
    data,
    page,
    updateRefreshStatus,
    entityId,
    siteName,
    siteOpportunityNumber,
    countryId,
  } = props;
  
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isAddPurchaseOrderPopupVisible, setAddPurchaseOrderPopupVisible] =
      useState(false);;
  const [isViewPurchaseOrderViewPopUp, setViewPurchaseOrderViewPopUp] =
    useState(false);

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  const deletePurchaseOrder = () => {
    setConfirmVisibility(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .delete(`/purchaseOrders/${data.id}`)
        .then(() => {
          updateRefeshStatus();
        })
        .catch((error) => {
          onRefreshData(true);
          handleApiError(error);
        })
        .finally(() => {
          setActionConfirmStatus(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const editNewPurchaseOrder = () => {
    setViewPurchaseOrderViewPopUp(false);
    setAddPurchaseOrderPopupVisible(true);
  };
  const closePurchaseOrderCreationPopup = () => {
    setAddPurchaseOrderPopupVisible(false);
  };

  const ViewPurchaseOrder = () => {
    setViewPurchaseOrderViewPopUp(true);
  };
  const closePurchaseOrderViewPopup = () => {
    setViewPurchaseOrderViewPopUp(false);
  };

  return (
    <>
      <ButtonContainer>
        <div>
          <Image
            src={viewIcon}
            alt={t("PURCHASE_ORDER_ACTION_TOOLTIP_VIEW_PDF")}
            title={t("PURCHASE_ORDER_ACTION_TOOLTIP_VIEW_PDF")}
            className="purchaseOrder-list__image-action-icon"
            onClick={ViewPurchaseOrder}
          />
          {[0].includes(parseInt(data.status, 10)) && (
            <Image
              src={editIcon}
              alt={t("GENERIC_ACTION_TOOLTIP_EDIT")}
              title={t("GENERIC_ACTION_TOOLTIP_EDIT")}
              className="purchaseOrder-list__image-action-icon"
              onClick={editNewPurchaseOrder}
            />
          )}
          {[0, 1].includes(parseInt(data.status, 10)) && (
            <Image
              src={deleteIcon}
              alt={t("PURCHASE_ORDER_ACTION_TOOLTIP_DELETE")}
              title={t("PURCHASE_ORDER_ACTION_TOOLTIP_DELETE")}
              className="purchaseOrder-list__image-action-icon"
              onClick={deletePurchaseOrder}
            />
          )}
        </div>
      </ButtonContainer>
      {isConfirmVisible && (
        <WarningPopUp
          title={t("PURCHASE_ORDER_CONFIRMATION_BOX_DELETE")}
          message={t("PURCHASE_ORDER_CONFIRMATION_BOX_DELETE_CONTENT")}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
      {isAddPurchaseOrderPopupVisible && (
        <AddEditPurchaseOrder
          context={page}
          isEditMode
          id={data.id}
          {...(page === "site"
            ? { siteId: entityId }
            : { companyId: entityId })}
          siteName={siteName}
          siteOpportunityNumber={siteOpportunityNumber}
          platformCountryId={countryId}
          onClose={closePurchaseOrderCreationPopup}
          updateRefreshStatus={updateRefreshStatus}
        />
      )}
      {isViewPurchaseOrderViewPopUp && (
        <PurchaseOrderView
          id={data.id}
          reference={data.reference}
          onClose={closePurchaseOrderViewPopup}
          updateRefreshStatus={updateRefreshStatus}
          editNewPurchaseOrder={editNewPurchaseOrder}
        />
      )}
    </>
  );
};

Action.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  updateRefeshStatus: PropTypes.func.isRequired,
};

export default withTranslation()(Action);
